import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'header-auth-box',
  templateUrl: './header-auth-box.html',
  styleUrl: './header-auth-box.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, FormsModule],
})
export class HeaderAuthBoxComponent {
  @Input() isLoggedIn: boolean = false;
  @Input() userInfo: any = undefined;
  @Input() user: any = {};
  @Input() newUser: any = {};
  @Input() currencies: any = [];

  @Output() login = new EventEmitter<void>();
  @Output() register = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  public showRegistration: boolean = false;
}
